/**
 * useFirstChallengeCreatePublisher — mounted INSIDE the create flow (where useCreatePage is available).
 * While the tour is active it publishes the create step + pick count to the tour store so the globally
 * mounted controller can derive the current tour step. Inert when the tour is not active.
 * See specs/first-challenge-onboarding/spec.md.
 */

import { useEffect } from 'react';
import { useCreatePage } from '../../create/contexts/CreatePageContext';
import { useFirstChallengeTourStore } from '../stores/firstChallengeTourStore';

export function useFirstChallengeCreatePublisher(): void {
  const active = useFirstChallengeTourStore((s) => s.active);
  const { step, pickSlips } = useCreatePage();
  const pickCount = pickSlips.length;

  useEffect(() => {
    if (!active) return;
    const store = useFirstChallengeTourStore.getState();
    store.setCreateState({ createStep: step, pickCount });
    if (step === 'success') store.markSent();
  }, [active, step, pickCount]);
}
